// iter87.509 (user-provided) — UEFA Champions League club brand color
// pairs [primary, secondary]. Dedicated map (not the EPL/La Liga
// "soccer" fallback `TeamSwatch` otherwise uses) because UCL's League
// Phase field spans clubs from leagues this app has no other color
// data for (Bundesliga, Serie A, Ligue 1, Eredivisie, Turkish,
// Portuguese, Belgian, Norwegian, Ukrainian, Czech, Slovak,
// Azerbaijani, Austrian, Greek). Primary already matches the
// user-specified dominant color for every club below (Arsenal/
// Liverpool/Bayern/Man United/PSV/Roma/Slavia Praha/Lille red;
// Man City/Porto/Napoli/Inter/PSG/Aston Villa blue; Dortmund/
// Villarreal/Bodø-Glimt/Galatasaray/Lens yellow; Sporting CP/Real
// Betis green; LASK black) — no reordering needed.
export const UCL_TEAM_COLORS = {
    "AEK Athens": ["#FFD100", "#000000"],
    "Arsenal": ["#EF0107", "#063672"],
    "Aston Villa": ["#95BFE5", "#670E36"],
    "Atletico Madrid": ["#CB3524", "#272E61"],
    "Atlético Madrid": ["#CB3524", "#272E61"],
    "Barcelona": ["#A50044", "#004D98"],
    "Bayern Munich": ["#DC052D", "#0066B2"],
    "Bayern München": ["#DC052D", "#0066B2"],
    "Bodo/Glimt": ["#F7D117", "#000000"],
    "Bodø/Glimt": ["#F7D117", "#000000"],
    "Borussia Dortmund": ["#FDE100", "#000000"],
    "Club Brugge": ["#000000", "#1A4FA3"],
    "Club Brugge KV": ["#000000", "#1A4FA3"],
    "Como": ["#003DA5", "#FFFFFF"],
    "Como 1907": ["#003DA5", "#FFFFFF"],
    "Fenerbahce": ["#001489", "#FFD100"],
    "Fenerbahçe": ["#001489", "#FFD100"],
    "Feyenoord": ["#E03A3E", "#000000"],
    "Galatasaray": ["#FDB912", "#A32638"],
    "Inter Milan": ["#00529F", "#000000"],
    "Inter": ["#00529F", "#000000"],
    "LASK": ["#000000", "#FFFFFF"],
    "Lens": ["#FFD100", "#C8102E"],
    "RC Lens": ["#FFD100", "#C8102E"],
    "Lille": ["#D71920", "#002B5C"],
    "LOSC Lille": ["#D71920", "#002B5C"],
    "Liverpool": ["#C8102E", "#00B2A9"],
    "Manchester City": ["#6CABDD", "#1C2C5B"],
    "Manchester United": ["#DA291C", "#FBE122"],
    "Napoli": ["#12A0D7", "#FFFFFF"],
    "Paris Saint-Germain": ["#004170", "#DA291C"],
    "Paris Saint Germain": ["#004170", "#DA291C"],
    "PSG": ["#004170", "#DA291C"],
    "Porto": ["#003399", "#FFFFFF"],
    "FC Porto": ["#003399", "#FFFFFF"],
    "PSV Eindhoven": ["#E31E24", "#FFFFFF"],
    "PSV": ["#E31E24", "#FFFFFF"],
    "Real Betis": ["#00954C", "#FFFFFF"],
    "Real Madrid": ["#FFFFFF", "#FEBE10"],
    "Roma": ["#8E1F2F", "#F7A800"],
    "AS Roma": ["#8E1F2F", "#F7A800"],
    "Sabah": ["#0057B8", "#FFFFFF"],
    "Shakhtar Donetsk": ["#F36F21", "#000000"],
    "Slavia Praha": ["#D7141A", "#FFFFFF"],
    "Slavia Prague": ["#D7141A", "#FFFFFF"],
    "Slovan Bratislava": ["#6BB4E8", "#001E62"],
    "Sporting CP": ["#008A3D", "#FFFFFF"],
    "Sporting Lisbon": ["#008A3D", "#FFFFFF"],
    "Stuttgart": ["#FFFFFF", "#E32219"],
    "VfB Stuttgart": ["#FFFFFF", "#E32219"],
    "Viking": ["#002F6C", "#FFFFFF"],
    "Viking FK": ["#002F6C", "#FFFFFF"],
    "Villarreal": ["#FFF200", "#005BAC"],
};

function hashColor(name) {
    let hash = 0;
    for (let i = 0; i < (name || "").length; i++) {
        hash = (hash * 31 + name.charCodeAt(i)) % 360;
    }
    return `hsl(${hash}, 55%, 38%)`;
}

// Returns [primary, secondary] — real brand pair when known, otherwise
// a deterministic single-hue fallback so an unmapped name still renders.
export function uclTeamColorPair(name) {
    return UCL_TEAM_COLORS[name] || [hashColor(name), hashColor(name)];
}
